import React from 'react';

interface ToggleProps {
  checked: boolean;
  label: string;
  onChange: (checked: boolean) => void;
}

export const Toggle: React.FC<ToggleProps> = ({ checked, label, onChange }) => {
  return (
    <label className="inline-flex items-center cursor-pointer gap-3">
      <div
        className={`w-11 h-6 rounded-full relative transition-all duration-300 border ${
          checked
            ? 'bg-[#3b82f6] border-[#3b82f6]/30'
            : 'bg-white/10 border-white/10'
        }`}
      >
        <div
          className={`w-5 h-5 rounded-full bg-white absolute top-0.5 left-0.5 transition-all duration-300 shadow-md ${
            checked ? 'translate-x-5 shadow-[#3b82f6]/40' : ''
          }`}
        />
      </div>
      <span className="text-sm font-medium">{label}</span>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="hidden"
      />
    </label>
  );
};

